import { useTranslation } from "react-i18next";
import LoaderDialog from "../../LoaderDialog";

const CreateSessionLoader = () => {
	const { t } = useTranslation();

	const messages = [
		{
			icon: "tune" as const,
			text: t("auth.createSessionLoader.configuringSession"),
		},
		{
			icon: "brain" as const,
			text: t("auth.createSessionLoader.analyzingMastery"),
		},
		{
			icon: "folder-download-outline" as const,
			text: t("auth.createSessionLoader.loadingContent"),
		},
	];

	return <LoaderDialog visible messages={messages} />;
};

export default CreateSessionLoader;
